// ProductDetails component goes in this file..
import React from 'react';

import '../../../assets/styles/product-styles/ProductDetails.scss';
// OR
// import '../../../assets/styles/product-styles/ProductDetails.css';

export default function ProductDetails() {
    return (
        <div>
            <h1>ProductDetails</h1>
        </div>
    )
}
